


















































































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { PayeeInformation } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import { PayoutRequest, PayoutRequestSettings } from "@scrile/api-provider/dist/api/PayoutRequestsProvider";
import { PayoutSystemSettings } from "@scrile/api-provider/dist/api/PayoutSystemSettingsProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import Accordion from "@/components/Accordion/Accordion.vue";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import FormatMoney from "@/components/FormatMoney";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import CreatePayoutRequestModal from "./CreatePayoutRequestModal.vue";
import RequestItem from "./RequestItem.vue";

export default defineComponent({
  name: "PayoutRequestsView",
  components: {
    CreatePayoutRequestModal,
    Accordion,
    RequestItem,
    FormatMoney,
    BasePage,
    BaseButton,
    BaseIcon,
    PageTitle,
    EmptyContent,
    InfiniteScroll,
  },
  props: {
    loading: { type: Boolean, required: true },
    enableScroll: { type: Boolean, required: true },
    primaryBalance: { type: Number, required: true },
    pendingBalance: { type: Number, required: true },
    requestErrorValue: { type: String, required: true },
    requestsList: { type: Array as PropType<PayoutRequest[]>, required: true },
    payeeInfo: { type: Object as PropType<PayeeInformation | null> },
    payoutSystemSettings: { type: Array as PropType<PayoutSystemSettings[]>, required: true },
    requestSettings: { type: Object as PropType<PayoutRequestSettings | null> },
  },
  setup(props, { emit }) {
    const { authorities } = useAuthUser();
    const allowNewRequest = computed(() => checkAuthorities(authorities.value, ["createMyPayoutRequest"]));
    const emptyRequests = computed(() => !props.loading && props.requestsList.length === 0);
    const mainCurrency = computed(() => getMainCurrencyCode());
    const isPendingBalanceOpen = ref(false);
    const showCreateRequestModal = ref(false);
    const processing = ref(false);

    const hasActiveRequest = computed(() => {
      return props.requestsList.some(i => i.status === "NEW") ?? false;
    });

    const payeeInfoEmpty = computed(() => !props.payeeInfo?.payoutSystem);

    const canCreateNewRequest = computed(() => {
      return (
        !props.loading &&
        allowNewRequest.value &&
        !hasActiveRequest.value &&
        !!props.requestSettings &&
        !payeeInfoEmpty.value
      );
    });

    const userPayoutSystem = computed(
      () => props.payoutSystemSettings.find(system => system.systemName === props.payeeInfo?.payoutSystem) || null
    );

    const togglePendingBalance = () => {
      isPendingBalanceOpen.value = !isPendingBalanceOpen.value;
    };

    const onSubmit = (value: string) => {
      processing.value = true;
      emit("createRequest", {
        value,
        cb: () => {
          showCreateRequestModal.value = false;
        },
        loadingCb: () => {
          processing.value = false;
        },
      });
    };

    return {
      processing,
      userPayoutSystem,
      showCreateRequestModal,
      hasActiveRequest,
      canCreateNewRequest,
      payeeInfoEmpty,
      allowNewRequest,
      emptyRequests,
      mainCurrency,
      isPendingBalanceOpen,
      togglePendingBalance,
      onSubmit,
    };
  },
});
